import React, { useState } from 'react';
import { Input, InputProps } from '../Input/Input';
import useTranslation from '../../hooks/useTranslation';

export interface PasswordInputProps extends InputProps {
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>
}

function PasswordInput({ buttonProps, type, ...rest } : PasswordInputProps) {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { translateText } = useTranslation();

  const togglePassword = (event: any) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };
  return (
    <div>
      <Input type={showPassword ? 'text' : 'password'} {...rest} />
      <button
        aria-label={translateText('password visibility toggle')}
        type="button"
        id="ies-toggle-btn"
        onClick={(event) => {
          togglePassword(event);
        }}
        {...buttonProps}
      >
        {showPassword ? (
          <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* eslint-disable-next-line max-len -- long lines are allowed for SVG */}
            <path fillRule="evenodd" clipRule="evenodd" d="M9.0001 0C13.0097 0 16.4475 2.47581 17.9001 5.99816C16.4475 9.52051 13.0097 11.9963 9.0001 11.9963C4.99047 11.9963 1.55267 9.52051 0.100098 5.99816C1.55267 2.47581 4.99047 0 9.0001 0ZM9.0001 1.75C6.03932 1.75 3.38001 3.41924 2.02936 5.99816C3.38001 8.57709 6.03932 10.2463 9.0001 10.2463C11.9609 10.2463 14.6202 8.57709 15.9708 5.99816C14.6202 3.41924 11.9609 1.75 9.0001 1.75ZM9.0001 2.5C10.9331 2.5 12.5001 4.067 12.5001 6C12.5001 7.933 10.9331 9.5 9.0001 9.5C7.0671 9.5 5.5001 7.933 5.5001 6C5.5001 4.067 7.0671 2.5 9.0001 2.5ZM9.0001 4.25C8.0336 4.25 7.2501 5.0335 7.2501 6C7.2501 6.9665 8.0336 7.75 9.0001 7.75C9.9666 7.75 10.7501 6.9665 10.7501 6C10.7501 5.0335 9.9666 4.25 9.0001 4.25Z" fill="#05112A" />
          </svg>
        ) : (
          <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* eslint-disable-next-line max-len -- long lines are allowed for SVG */}
            <path fillRule="evenodd" clipRule="evenodd" d="M3.49882 0.761286L15.7318 12.9942C16.0735 13.3359 16.0735 13.89 15.7318 14.2317C15.3901 14.5734 14.836 14.5734 14.4943 14.2317L12.9195 12.6568C11.722 13.1964 10.3957 13.4963 9.0001 13.4963C4.99047 13.4963 1.55267 11.0205 0.100098 7.49817C0.812404 5.77089 2.0021 4.29527 3.50251 3.23985L2.26138 1.99872C1.91967 1.65701 1.91967 1.103 2.26138 0.761286C2.60309 0.419578 3.15711 0.419578 3.49882 0.761286ZM4.76289 4.50023C3.62496 5.23474 2.67681 6.26193 2.02936 7.49817C3.38001 10.0771 6.03932 11.7463 9.0001 11.7463C9.89449 11.7463 10.7614 11.594 11.573 11.3103L10.4109 10.1482C9.99038 10.3727 9.5101 10.5 9.0001 10.5C7.34325 10.5 6.0001 9.15686 6.0001 7.50001C6.0001 6.99001 6.12736 6.50973 6.35186 6.0892L4.76289 4.50023ZM9.0001 1.50001C13.0097 1.50001 16.4475 3.97582 17.9001 7.49817C17.413 8.67937 16.7026 9.74287 15.8223 10.6348L14.5858 9.39829C15.132 8.84371 15.6006 8.20512 15.9708 7.49817C14.6202 4.91924 11.9609 3.25001 9.0001 3.25001C8.81763 3.25001 8.63632 3.25635 8.45638 3.26885L6.91599 1.72845C7.58712 1.57886 8.2845 1.50001 9.0001 1.50001Z" fill="#05112A" />
          </svg>
        )}
      </button>
      <span aria-live="polite" className="sr-only">
        {showPassword ? translateText('Password is visible') : translateText('Password is hidden')}
      </span>
    </div>
  );
}

export default PasswordInput;
